import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { SearchIcon, FilterIcon, DownloadIcon, UserPlusIcon, CheckCircle2Icon, XCircleIcon, MailIcon, MoreHorizontalIcon } from 'lucide-react';
export function AttendeesPage() {
  const attendees = [{
    id: 1,
    name: 'Sarah Mitchell',
    role: 'VP of Sales',
    email: 'sarah@example.com',
    intake: true,
    wellness: 'Yoga, Spa',
    dietary: 'None',
    group: 'Pod A'
  }, {
    id: 2,
    name: 'David Chen',
    role: 'Engineering Dir.',
    email: 'david@example.com',
    intake: true,
    wellness: 'Hike',
    dietary: 'Vegetarian',
    group: 'Pod B'
  }, {
    id: 3,
    name: 'Emily Taylor',
    role: 'Product Lead',
    email: 'emily@example.com',
    intake: false,
    wellness: '-',
    dietary: '-',
    group: 'Pending'
  }, {
    id: 4,
    name: 'Michael Ross',
    role: 'Marketing VP',
    email: 'michael@example.com',
    intake: true,
    wellness: 'Quiet Time',
    dietary: 'GF',
    group: 'Pod A'
  }, {
    id: 5,
    name: 'Jessica Wong',
    role: 'Design Head',
    email: 'jessica@example.com',
    intake: true,
    wellness: 'Spa, Hike',
    dietary: 'None',
    group: 'Pod C'
  }, {
    id: 6,
    name: 'Robert Fox',
    role: 'Operations',
    email: 'robert@example.com',
    intake: false,
    wellness: '-',
    dietary: '-',
    group: 'Pending'
  }, {
    id: 7,
    name: 'Amanda Cooper',
    role: 'HR Director',
    email: 'amanda@example.com',
    intake: true,
    wellness: 'Yoga',
    dietary: 'Vegan',
    group: 'Pod B'
  }];
  return <DashboardLayout pageTitle="Attendees" breadcrumb="Leadership Reset Retreat" data-id="element-693">
      {/* Stats Row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-694">
        <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm" data-id="element-695">
          <div className="text-sm text-slate-500 font-medium mb-1" data-id="element-696">
            Total Attendees
          </div>
          <div className="text-2xl font-bold text-brand-navy" data-id="element-697">48</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm" data-id="element-698">
          <div className="text-sm text-slate-500 font-medium mb-1" data-id="element-699">
            Intake Complete
          </div>
          <div className="text-2xl font-bold text-emerald-600" data-id="element-700">
            41 <span className="text-sm font-normal text-slate-400" data-id="element-701">(85%)</span>
          </div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm" data-id="element-702">
          <div className="text-sm text-slate-500 font-medium mb-1" data-id="element-703">
            Dietary Notes
          </div>
          <div className="text-2xl font-bold text-amber-600" data-id="element-704">12</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm" data-id="element-705">
          <div className="text-sm text-slate-500 font-medium mb-1" data-id="element-706">
            Groups Assigned
          </div>
          <div className="text-2xl font-bold text-brand-teal" data-id="element-707">
            41 <span className="text-sm font-normal text-slate-400" data-id="element-708">(85%)</span>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-709">
        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-710">
          <div className="relative flex-1 sm:w-80" data-id="element-711">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-712" />
            <input type="text" placeholder="Search attendees..." className="w-full pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-713" />
          </div>
          <Button variant="outline" size="sm" className="px-3" data-id="element-714">
            <FilterIcon className="w-4 h-4" data-id="element-715" />
          </Button>
        </div>
        <div className="flex gap-2 w-full sm:w-auto" data-id="element-716">
          <Button variant="outline" size="sm" data-id="element-717">
            <DownloadIcon className="w-4 h-4 mr-2" data-id="element-718" />
            Export
          </Button>
          <Button variant="primary" size="sm" data-id="element-719">
            <UserPlusIcon className="w-4 h-4 mr-2" data-id="element-720" />
            Add Attendee
          </Button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-721">
        <div className="overflow-x-auto" data-id="element-722">
          <table className="w-full text-left text-sm" data-id="element-723">
            <thead className="bg-slate-50 border-b border-slate-200 text-slate-600 font-medium" data-id="element-724">
              <tr data-id="element-725">
                <th className="px-6 py-4" data-id="element-726">Attendee</th>
                <th className="px-6 py-4" data-id="element-727">Intake Status</th>
                <th className="px-6 py-4" data-id="element-728">Wellness Prefs</th>
                <th className="px-6 py-4" data-id="element-729">Dietary</th>
                <th className="px-6 py-4" data-id="element-730">Group</th>
                <th className="px-6 py-4 text-right" data-id="element-731">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-732">
              {attendees.map(a => <tr key={a.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-733">
                  <td className="px-6 py-4" data-id="element-734">
                    <div className="flex items-center gap-3" data-id="element-735">
                      <div className="w-8 h-8 rounded-full bg-brand-navy/10 text-brand-navy flex items-center justify-center font-bold text-xs" data-id="element-736">
                        {a.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div data-id="element-737">
                        <div className="font-medium text-slate-900" data-id="element-738">
                          {a.name}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-739">{a.role}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-740">
                    {a.intake ? <span className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 text-xs font-medium px-2.5 py-1 rounded-full" data-id="element-741">
                        <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-742" /> Complete
                      </span> : <span className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 text-xs font-medium px-2.5 py-1 rounded-full" data-id="element-743">
                        <XCircleIcon className="w-3.5 h-3.5" data-id="element-744" /> Pending
                      </span>}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-745">{a.wellness}</td>
                  <td className="px-6 py-4" data-id="element-746">
                    {a.dietary !== 'None' && a.dietary !== '-' ? <span className="bg-orange-50 text-orange-700 text-xs font-medium px-2 py-1 rounded-md" data-id="element-747">
                        {a.dietary}
                      </span> : <span className="text-slate-400" data-id="element-748">{a.dietary}</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-749">
                    <span className={`text-xs font-medium px-2 py-1 rounded-md ${a.group === 'Pending' ? 'bg-slate-100 text-slate-500' : 'bg-brand-teal/10 text-brand-teal'}`} data-id="element-750">
                      {a.group}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-751">
                    <div className="flex items-center justify-end gap-2" data-id="element-752">
                      {!a.intake && <button className="p-1.5 text-slate-400 hover:text-brand-teal hover:bg-brand-teal/10 rounded-md transition-colors" title="Send Reminder" data-id="element-753">
                          <MailIcon className="w-4 h-4" data-id="element-754" />
                        </button>}
                      <button className="p-1.5 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-md transition-colors" data-id="element-755">
                        <MoreHorizontalIcon className="w-4 h-4" data-id="element-756" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-sm text-slate-500" data-id="element-757">
          <div data-id="element-758">Showing 1 to 7 of 48 attendees</div>
          <div className="flex gap-1" data-id="element-759">
            <Button variant="outline" size="sm" className="px-3" disabled data-id="element-760">
              Previous
            </Button>
            <Button variant="outline" size="sm" className="px-3" data-id="element-761">
              Next
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}